<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="tabTitle"
      [canGoBack]="true"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true">
    @if (loaded) {
      @if (selectedTab === 'upsells') {
        <upsells-tab />
      }

      @if (selectedTab === 'listings') {
        <channels-tab [selectedProperty]="selectedProperty" />
      }

      @if (selectedTab === 'leasing') {
        <units-content />
      }

      @if (selectedTab === 'reviews') {
        <reviews-tab />
      }

      @if (selectedTab === 'wifi') {
        <wifi-tab />
      }

      @if (selectedTab === 'happiness') {
        <happiness-tab />
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />
